// Lib
import React from 'react';

// Components
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import LabelEditContent from '../edit/LabelEditContent';
import LabelColorPopup from './LabelColorPopup';

// Constants
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';

// Types
import { Label } from '../../../../../../../common/labels/labelTypes';

type Props = {
    label: Label | null;
    showColorMenu: boolean;
    onColorChangeClick: () => void;
    showEditingPopup: boolean;
    setShowEditingPopup: (show: boolean) => void;
};

const LabelEditPopup = (props: Props) => {
    const { label, showEditingPopup, setShowEditingPopup, onColorChangeClick, showColorMenu } = props;

    if (!label) return null;

    return (
        <FloatingPanel
            className="LabelEditPopup light !w-auto !p-0 !overflow-hidden"
            selector={`#label-${label.id}`}
            pollPosition
            offset={20}
            showArrow={false}
            distance={20}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
            show={showEditingPopup}
        >
            <PopupPanelMouseManager
                visible={showEditingPopup}
                popupId={PopupIds.LABEL_EDIT_MENU}
                closePopup={() => setShowEditingPopup(false)}
            >
                <div className="-mx-[2.4rem]">
                    <LabelEditContent label={label} onColorChangeClick={onColorChangeClick} />
                </div>
                <LabelColorPopup label={label} showColorMenu={showColorMenu} />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default LabelEditPopup;
